const CATEGORY_COLORS = {
  vip: { dot: "#4CAF50", bg: "#C8E6C9", border: "#4CAF50" },
  email: { dot: "#FF9800", bg: "#FFE0B2", border: "#FF9800" },
  complain: { dot: "#FFEB3B", bg: "#FFF9C4", border: "#FFEB3B" },
};

const CATEGORY_PRIORITY = ["vip", "email", "complain"];

const NO_CATEGORY = { background: "#F5F5F5", border: "#E0E0E0" };

export function getCardColors(categories) {
  if (!categories || categories.length === 0) return NO_CATEGORY;
  for (const cat of CATEGORY_PRIORITY) {
    if (categories.includes(cat)) {
      return { background: CATEGORY_COLORS[cat].bg, border: CATEGORY_COLORS[cat].border };
    }
  }
  return NO_CATEGORY;
}

export function getCategoryDots(categories) {
  if (!categories || categories.length === 0) return [];
  return CATEGORY_PRIORITY
    .filter((cat) => categories.includes(cat))
    .map((cat) => ({ category: cat, color: CATEGORY_COLORS[cat].dot }));
}

export { CATEGORY_COLORS, CATEGORY_PRIORITY };
